export default __webpack_public_path__ + "static/media/leaderboard.1faf013e.gif";